<template>
    <div class="rounded-5 w-100 my-4 px-4">
        <div class="bg-white w-100 rounded-4 border">
            <h1
                class="px-5 py-3 page-heading"
                style="background: #f1f7ff; font-weight: bold; border-radius: 14px 14px 0 0"
            >
                Theme Customization
            </h1>

            <div class="p-4">
                <div class="w-100 mx-3">
                    <h3 style="font-weight: 700">Color Scheme</h3>
                </div>
                <div class="d-grid color-box" style="margin: 1.2rem 0rem">
                    <div class="m-4">
                        <label class="d-flex py-2" style="gap: 1%" for="customized_color">
                            <div class="w-25">
                                <input
                                    type="color"
                                    v-model="appColors.primary_color"
                                    @input="handleAppColorChange"
                                    class="w-100"
                                />
                            </div>
                            <div class="w-25">
                                <input
                                    type="color"
                                    v-model="appColors.primary_text_color"
                                    @input="handleAppColorChange"
                                    class="w-100"
                                />
                            </div>
                            <div class="w-25">
                                <input
                                    type="color"
                                    v-model="appColors.secondary_color"
                                    @input="handleAppColorChange"
                                    class="w-100"
                                />
                            </div>
                            <div class="w-25">
                                <input
                                    type="color"
                                    v-model="appColors.secondary_text_color"
                                    @input="handleAppColorChange"
                                    class="w-100"
                                />
                            </div>
                        </label>
                        <label class="d-flex py-2 w-100" style="gap: 1%">
                            <div
                                class="d-flex align-items-center w-25 justify-content-center"
                                style="font-weight: 600; color: #000; font-size: 12px"
                            >
                                Primary Color
                            </div>
                            <div
                                class="d-flex align-items-center w-25 justify-content-center"
                                style="font-weight: 600; color: #000; font-size: 12px"
                            >
                                Primary Text Color
                            </div>
                            <div
                                class="d-flex align-items-center w-25 justify-content-center"
                                style="font-weight: 600; color: #000; font-size: 12px"
                            >
                                Secondary Color
                            </div>
                            <div
                                class="d-flex align-items-center w-25 justify-content-center"
                                style="font-weight: 600; color: #000; font-size: 12px"
                            >
                                Secondary Text Color
                            </div>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CustomisedThemeDesign',
        components: {},
        props: {
            applicationData: {
                type: Object,
            },
            errors: {
                type: Object,
            },
        },
        data() {
            return {
                appColors: null,
            };
        },
        methods: {
            handleAppColorChange() {
                this.$emit('captureValues', { applicationData: { color_configuration: { ...this.appColors } } });
            },
        },
        async created() {
            window.scrollTo(0, 0);

            const { color_configuration } = this.applicationData;

            if (color_configuration) {
                this.appColors = { ...color_configuration };
            }
        },
    };
</script>

<style scoped>
    .color-box {
        width: 100%;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0px 20px 20px 0px rgba(0, 0, 0, 0.12);
    }
</style>
